export enum GatewayStatus {
  HEALTHY = 'HEALTHY',
  UNHEALTHY = 'UNHEALTHY',
  UNREGISTERED = 'UNREGISTERED',
}

// keep in sync with services/instruments/client/openapi.yaml GatewayType
export enum GatewayType {
  GREENGRASS = 'GREENGRASS',
  S3 = 'S3',
}

export const GATEWAY_TYPE_TO_DISPLAY: Record<GatewayType, string> = {
  [GatewayType.GREENGRASS]: 'Local Windows',
  [GatewayType.S3]: 'S3 Cloud',
};

export interface InstrumentGateway {
  // TODO Other attributes on GatewayResource are also nullable, but not in practice, fix in openapi.yaml
  id: string;
  name: string;
  gatewayType: GatewayType;
  status: GatewayStatus;
  isArchived: boolean;
  installerVersion?: string;
  jdkVersion?: string;
  customerBucket?: string;
}

// keep this in sync with services/instruments/src/shared/models/gateway.py
// TODO (BNCH-89423) have this magic constant be sent through from the backend instead
export const LATEST_BASE_GATEWAY_INSTALLER_VERSION = '1.1.0';
